module.exports = __webpack_public_path__ + "static/media/29ADMSPC5.f67233e8.jpg";